// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d834729","239":"6bea34bc","453":"8f456eb0","667":"b8a31c84"}[chunkId] + ".chunk.js";
};